import { DateTime } from "luxon";

export default {
  methods: {
    currencyFormatter(value, options = {}) {
      // Number(), not new Number(): a Number wrapper object is never NaN to
      // Number.isNaN, so unparseable input used to render as "$NaN".
      const number = Number(value);

      if (Number.isNaN(number)) {
        return "N/A";
      }

      return number.toLocaleString(undefined, { style: "currency", currency: "USD", ...options });
    },

    dateTimeFormatter(value, format) {
      if (!value) {
        return "";
      }

      if (typeof value === "object" && value.date) {
        value = value.date;
      }

      if (typeof format === "object") {
        format = format.dateFormat;
      }

      return DateTime.fromISO(value).toLocaleString(DateTime[format] || DateTime.DATE_MED);
    },

    methodFormatter(value) {
      if (["dwolla", "check", "stripe", "amazon"].includes(value)) {
        return "Bank Transfer";
      }

      return value === "paypal" ? "PayPal" : "";
    },
  },
};
